import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAnthropicFilledIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 25,
	viewBox: "0 0 25 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 25,
			height: 25,
			rx: 5,
			fill: "#FAFAFA"
		}),
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_11327_9883)",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M14.2161 6.99384L18.8377 18.0062H21.3721L16.7505 6.99384H14.2161Z",
				fill: "#252B37"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M8.6748 13.8554L10.2562 9.98537L11.8375 13.8554H8.6748ZM8.93117 7.20081L4.3103 18.2132H6.89401L7.83906 15.9006H12.6734L13.6183 18.2132H16.202L11.5811 7.20081H8.93117Z",
				fill: "#252B37"
			})]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_11327_9883",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 17.2414,
				height: 16.3793,
				fill: "white",
				transform: "translate(4.3103 4.31036)"
			})
		}) })
	]
});
export default SvgAnthropicFilledIcon;
